const imgGallery = document.querySelectorAll('.image-gallery');
const galleryNext = document.querySelector('.gallery-next');
const galleryPrevious = document.querySelector('.gallery-previous');
if(imgGallery.length > 0) {

    let imageThumbnail = document.querySelectorAll(".gallery-th img");
    //on click of thumbnail run the imageChanger function
    imageThumbnail.forEach(function(image) {
      image.addEventListener("click", imageChanger);
    });
    

    //set the next/prev variables
    
    //Click event on next button
    galleryNext.addEventListener('click', function() {
      //get the active thumb
      let activeThumb = document.querySelector('.active-th');
      //If the active thumb is the last child, disable the next button
      if(activeThumb == imageThumbnail.lastElementChild) {
        galleryNext.setAttribute('disabled', true);
      //If not last child, add/remove classes, add/remove dsiabled
      } else {
        activeThumb.nextElementSibling.classList.add('active-th');
        activeThumb.classList.remove('active-th');
        galleryNext.removeAttribute('disabled');
        galleryPrevious.removeAttribute('disabled');
        //Set the image src of the large image to the active thumb image src
        let imagePreview = document.querySelector("#gallery-preview img");
        imagePreview.src = activeThumb.nextElementSibling.children[0].src;
      }
    });

    //Same as above but for the previous button
    galleryPrevious.addEventListener('click', function() {
      let activeThumb = document.querySelector('.active-th');
      if(activeThumb == imageThumbnail.firstElementChild) {
        galleryPrevious.setAttribute('disabled', true);
      } else {
        activeThumb.previousElementSibling.classList.add('active-th');
        activeThumb.classList.remove('active-th');
        galleryPrevious.removeAttribute('disabled');
        galleryNext.removeAttribute('disabled');
        let imagePreview = document.querySelector("#gallery-preview img");
        imagePreview.src = activeThumb.previousElementSibling.children[0].src;
      }
    });
}

//Image changer if clicking directly on the thumbnail
function imageChanger(e) {
  //Set the src of large image to the thumbnail clicked
  let imagePreview = document.querySelector("#gallery-preview img");
  imagePreview.src = e.target.src;
  //Remove active class
  const allThumbs = document.querySelectorAll('.gallery-th');
  allThumbs.forEach(function(thumb) {
    thumb.classList.remove('active-th');
  });
  //Add active class to the thumbnail parent
  e.target.parentNode.classList.add('active-th');
  let imageThumbnail = document.querySelector(".thumbnails");
  if(e.target.parentNode == imageThumbnail.firstElementChild) {
    galleryPrevious.setAttribute('disabled', true);
    galleryNext.removeAttribute('disabled');
  } else if(e.target.parentNode == imageThumbnail.lastElementChild) {
    galleryNext.setAttribute('disabled', true);
    galleryPrevious.removeAttribute('disabled');
  } else {
    galleryPrevious.removeAttribute('disabled');
    galleryNext.removeAttribute('disabled');
  }
}
    